<script>
	import IssueTab from "./IssueTab.svelte";

	export let detailData;

	let reportSection = "Drive";
</script>

<IssueTab {reportSection} {detailData} />
